/*
 * Feature detection executed before app mount (Story 1.19 AC4).
 * If any required API is missing, BrowserUnsupported is rendered statically
 * by main.js and Vue never mounts. Don't add features here that aren't truly
 * required for the dashboard to function.
 */

export function detectMissingFeatures() {
  const w = typeof window !== 'undefined' ? window : globalThis;
  const missing = [];

  if (typeof w.fetch !== 'function') missing.push('fetch');
  if (typeof w.Promise !== 'function') missing.push('Promise');
  if (typeof w.requestAnimationFrame !== 'function') missing.push('requestAnimationFrame');
  if (!w.Intl || typeof w.Intl.DateTimeFormat !== 'function') missing.push('Intl.DateTimeFormat');
  if (!w.crypto || typeof w.crypto.randomUUID !== 'function') missing.push('crypto.randomUUID');
  if (typeof w.AbortController !== 'function') missing.push('AbortController');
  if (typeof w.URLSearchParams !== 'function') missing.push('URLSearchParams');
  // ES2020+ language features rely on syntax — those are caught by parse-time
  // SyntaxError, not feature detection. Vite's `target: es2020` handles them.

  return missing;
}

export function isBrowserSupported() {
  return detectMissingFeatures().length === 0;
}
